import { combineReducers } from "redux";
import { connectRouter, RouterState } from "connected-react-router";

import { UIData } from "./UIState/types";
import { UserData } from "./userData/types";
import { SessionsData } from "./sessions/types";
import { EmailFlowData } from "./emailFlow/types";
import { MainFlowData } from "./mainFlow/types";

import UIReducer from "./UIState/reducer";
import userDataReducer from "./userData/reducer";
import sessionsReducer from "./sessions/reducer";
import emailFlowReducer from "./emailFlow/reducer";
import mainFlowReducer from "./mainFlow/reducer";

export interface ReducerData {
  userData: UserData;
  sessions: SessionsData;
  emailFlow: EmailFlowData;
  mainFlow: MainFlowData;
  loadingData: UIData;
  router: RouterState;
}

const createRootReducer = (history: any) =>
  combineReducers({
    userData: userDataReducer,
    sessions: sessionsReducer,
    mainFlow: mainFlowReducer,
    emailFlow: emailFlowReducer,
    UIState: UIReducer,
    router: connectRouter(history),
  });

export default createRootReducer;
